import { PropertyName } from 'src/app/core/enumerations/sectionNames';
import { OrderFormSection } from './../../core/classes/orderFieldConfig';
import { Directive, Input, ViewContainerRef, OnInit, Renderer2, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { OrderCheckboxFormComponent } from './checkbox-form/checkbox-form.component';
import { OrderDateTimePickerFormComponent } from './order-date-time-picker-form/order-date-time-picker-form.component';
import { OrderInputCompComponent } from './input-comp/input-comp.component';
import { OrderInputNumCompComponent } from './input-num-comp/input-num-comp.component';
import { OrderRadioButtonFormComponent } from './radio-button-form/radio-button-form.component';
import { OrderSelectFormComponent } from './select-form/select-form.component';
import { OrderSelectSearchBoxComponent } from './select-search-box/select-search-box.component';
import { OrderTimepickerFormComponent } from './timepicker-form/timepicker-form.component';
import { OrderDatepickerFormComponent } from './order-datepicker-form/order-datepicker-form.component';
import { SampleSourceComponent } from './sample-source/sample-source.component';
import { SelectSearchBoxApiComponent } from './select-search-box-api/select-search-box-api.component';

const componentMapper = {
  TextBox: OrderInputCompComponent,
  NumberBox : OrderInputNumCompComponent,
  DropDown: OrderSelectFormComponent,
  RadioButton : OrderRadioButtonFormComponent,
  DatePicker : OrderDatepickerFormComponent,
  CheckBox: OrderCheckboxFormComponent,
  selectSearchBox: OrderSelectSearchBoxComponent,
  DateTimePicker: OrderDateTimePickerFormComponent,
  TimePicker: OrderTimepickerFormComponent,
  SampleSource: SampleSourceComponent,
  SelectSearchBoxApi: SelectSearchBoxApiComponent
};

@Directive({
    selector: '[appOrderDynamic]',
    standalone: false
})
export class OrderDynamicDirective implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: UntypedFormGroup;
  @Input() groups: UntypedFormArray;
  @Input() parentOrderForm: UntypedFormArray;
  @Input() accountPreferences: OrderFormSection[];

 @Output() selectValueChange  = new EventEmitter<string>();
  componentRef: any;

  constructor(
    private container: ViewContainerRef, private renderer: Renderer2) { }

    ngOnInit() {
      this.componentRef = this.container.createComponent(componentMapper[
      (this.field.type) ? (this.field.labelCode === PropertyName.SampleSource ? 'SampleSource' : (this.field.type)) : 'TextBox']);
      this.componentRef.instance.field = this.field;
      this.componentRef.instance.group = this.group;
      this.componentRef.instance.groups = this.groups;
      this.componentRef.instance.parentOrderForm = this.parentOrderForm;
      this.componentRef.instance.accountPreferences = this.accountPreferences;
      if (this.field.isScannable && this.field.type === 'selectSearchBox') {
      this.componentRef.instance.selectValueChangeObservable.subscribe(data => {
        this.selectValueChange.emit(data);
      });
      }
    }


}
